import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatApiError } from "@/lib/format";
import { toast } from "sonner";

export function SentenceShopModal({ side, onClose }) {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    api.get("/sentence/items").then(({ data }) => setItems(data[side] || [])).catch(() => setItems([]));
  }, [side]);

  const buy = async (item) => {
    if (busy) return;
    setBusy(item.id);
    try {
      const { data } = await api.post("/sentence/items/checkout", { item_id: item.id, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setBusy(null);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 fade-in" style={{ background: "rgba(0,0,0,0.75)" }} onClick={onClose} data-testid="sentence-shop-overlay">
      <div className="w-full max-w-sm p-8" style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }} onClick={(e) => e.stopPropagation()} data-testid="sentence-shop-modal">
        <div className="flex justify-between items-start mb-6">
          <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }} data-testid="sentence-shop-title">{side}</span>
          <button onClick={onClose} data-testid="sentence-shop-close" className="text-sm opacity-60 hover:opacity-100" style={{ color: "var(--text-primary)" }}>[ close ]</button>
        </div>
        {items === null ? (
          <p className="text-sm" style={{ color: "var(--text-muted)" }}>…</p>
        ) : (
          <ul className="flex flex-col gap-3">
            {items.map((it) => (
              <li key={it.id}>
                <button onClick={() => buy(it)} disabled={!!busy} data-testid={`sentence-shop-item-${it.id}`} className="btn w-full px-4 py-3 text-sm tracking-widest flex justify-between">
                  <span>{busy === it.id ? "…" : it.name}</span>
                  <span data-testid={`sentence-shop-price-${it.id}`}>${it.price_cad} CAD</span>
                </button>
              </li>
            ))}
          </ul>
        )}
        <p className="text-xs mt-6" style={{ color: "var(--text-muted)" }}>100% goes to the pot</p>
      </div>
    </div>
  );
}
